import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenInNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_385_14699",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 3,
		y: 3,
		width: 18,
		height: 18,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30772C3.5 4.80258 3.675 4.37502 4.025 4.02502C4.375 3.67502 4.80257 3.50002 5.3077 3.50002H10.8654C11.0782 3.50002 11.2564 3.57182 11.4 3.71542C11.5435 3.859 11.6153 4.0372 11.6153 4.25002C11.6153 4.46283 11.5435 4.64103 11.4 4.78462C11.2564 4.9282 11.0782 4.99999 10.8654 4.99999H5.3077C5.23077 4.99999 5.16024 5.03204 5.09612 5.09614C5.03202 5.16026 4.99997 5.23078 4.99997 5.30772V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9038C5.16024 18.9679 5.23077 19 5.3077 19H18.6923C18.7692 19 18.8397 18.9679 18.9038 18.9038C18.9679 18.8397 19 18.7692 19 18.6923V13.1346C19 12.9218 19.0718 12.7436 19.2154 12.6C19.3589 12.4564 19.5371 12.3846 19.75 12.3846C19.9628 12.3846 20.141 12.4564 20.2845 12.6C20.4282 12.7436 20.5 12.9218 20.5 13.1346V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM19 6.05382L10.2461 14.8077C10.1077 14.9461 9.93363 15.017 9.72403 15.0202C9.51441 15.0234 9.33717 14.9525 9.1923 14.8077C9.04743 14.6628 8.975 14.4872 8.975 14.2808C8.975 14.0743 9.04743 13.8987 9.1923 13.7538L17.9461 4.99999H14.75C14.5371 4.99999 14.3589 4.9282 14.2154 4.78462C14.0718 4.64103 14 4.46283 14 4.25002C14 4.0372 14.0718 3.859 14.2154 3.71542C14.3589 3.57182 14.5371 3.50002 14.75 3.50002H19.5961C19.8538 3.50002 20.0688 3.58624 20.2413 3.75869C20.4137 3.93112 20.5 4.14618 20.5 4.40387V9.25002C20.5 9.46283 20.4282 9.64103 20.2845 9.78462C20.141 9.9282 19.9628 9.99999 19.75 9.99999C19.5371 9.99999 19.3589 9.9282 19.2154 9.78462C19.0718 9.64103 19 9.46283 19 9.25002V6.05382Z",
			fill: "#1C1B1F"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_385_14699)",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#333333"
		})
	})]
});
export default SvgOpenInNew;
